import { Box, useTheme } from "@compass/core";
import { Select } from "components";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "redux/store";
import { getNavMenuItems, NavMenuItem } from "routes";

type SearchItem = { title: string; path: string };

export const AppTopBarSearch = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const appRoleId = useSelector((state: RootState) => state.app.roleId);
  const appReactMenus = useSelector((state: RootState) => state.app.reactMenus);
  const [navMenuItems, setNavMenuItems] = useState<NavMenuItem[] | undefined>();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (appRoleId && appReactMenus) {
      setNavMenuItems(getNavMenuItems(appReactMenus, appRoleId));
    }
  }, [appRoleId, appReactMenus]);

  let searchItems: SearchItem[] = [];

  if (navMenuItems) {
    for (let i = 0; i < navMenuItems.length; i++) {
      const menuItem = navMenuItems[i];

      for (let j = 0; j < menuItem.subMenuItems.length; j++) {
        const menuSubItem = menuItem.subMenuItems[j];

        if (!(menuSubItem.subSubMenuItems && menuSubItem.subSubMenuItems.length > 0))
          searchItems.push({ title: `${menuItem.title} > ${menuSubItem.title}`, path: menuSubItem.path! });
        else {
          for (let k = 0; menuSubItem.subSubMenuItems && k < menuSubItem.subSubMenuItems.length; k++) {
            const menuSubSubItem = menuSubItem.subSubMenuItems[k];

            searchItems.push({
              title: `${menuItem.title} > ${menuSubItem.title} > ${menuSubSubItem.title}`,
              path: menuSubSubItem.path,
            });
          }
        }
      }
    }
  }

  return (
    <Select
      autoFocus
      inputSx={{ 
          width: "100%",
          idth: "100%",
          // Targets internal MUI icon container to hide the arrow
          "& .MuiAutocomplete-endAdornment": {
              display: "none"
          },
        "& .MuiInputBase-root": {
          height: 40,
          borderRadius: "20px",
        },
        "& .Mui-focused fieldset": {
          border: `1px solid ${theme.palette.primary.main} !important`,
        }
      }}
      options={searchItems}
      getOptionLabel={(option) => option.title!}
      onChange={(e, value) => {
        navigate(value.path);
        setOpen(false);
      }}
      onInputChange={(event, newInputValue) => {
        if (newInputValue.length > 0) {
          setOpen(true);
        } else {
          setOpen(false);
        }
      }}
      onBlur={() => {
        setOpen(false);
      }}
      size="small"
      placeholder="Search Compass"
      open={open}
      popupIcon={null}
    />
  );
};